import { render, staticRenderFns } from "./PesquisaLegislacaoShow.vue?vue&type=template&id=3faf4a08&scoped=true"
import script from "./PesquisaLegislacaoShow.vue?vue&type=script&lang=js"
export * from "./PesquisaLegislacaoShow.vue?vue&type=script&lang=js"
import style0 from "./PesquisaLegislacaoShow.vue?vue&type=style&index=0&id=3faf4a08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3faf4a08",
  null
  
)

export default component.exports